import { render } from "./Cart.vue?vue&type=template&id=2cc4f451&bindings={\"total\":\"setup\",\"goBack\":\"setup\",\"goTo\":\"setup\",\"onChange\":\"setup\",\"onSubmit\":\"setup\",\"deleteGood\":\"setup\",\"groupChange\":\"setup\",\"allCheck\":\"setup\"}"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script